// Auto-generated normalizer for table: Empleados
export function empleadosNormalize(row) {
  return {
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    idPersona: row.idPersona ?? row.IdPersona ?? row['IdPersona'] ?? 0,
    numeroEmpleado: row.numeroEmpleado ?? row.NumeroEmpleado ?? row.Numero_Empleado ?? row.numero_Empleado ?? row.numero_empleado ?? '',
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row.idEmpresaEfectiva ?? row.IdEmpresaEfectiva ?? null,
  };
}
